// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3H6Xz","notes":"Notes_notes__1C6yc"};